<template>
  <b-button v-if="this.params.data && !this.params.data.hideLink"
            class="icon-button app-ctrl-border" 
            pill 
            variant="outline-primary"
            @click="handler">
    <font-awesome-icon :icon="['far', 'arrow-alt-right' ]"></font-awesome-icon>
  </b-button>
</template>

<script>
import EventBus from "@/services/EventBus.js";

export default {
  methods: {
    handler(ev) {
      if (this.params.data.ClientLocationId || this.params.data.LocationId) {
        EventBus.$emit("show-retailer-details-clicked", this.params.data.ClientLocationId || this.params.data.LocationId);
      } else {
        EventBus.$emit("show-market-details-clicked", this.params.data?.CountryId, this.params.data);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .icon-button {
    height: 1.75rem; 
    width: 1.75rem; 
    padding: 0px;
  }
</style>